var _path;
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.571 4H7.43A3.429 3.429 0 004 7.429V32.57A3.429 3.429 0 007.429 36h9.803V25.12h-4.5V20h4.5v-3.903c0-4.44 2.643-6.891 6.69-6.891 1.94 0 3.967.345 3.967.345v4.358h-2.234c-2.2 0-2.887 1.365-2.887 2.766V20h4.913l-.786 5.12h-4.127V36h9.803A3.429 3.429 0 0036 32.571V7.43A3.428 3.428 0 0032.571 4z"
  })));
}
export default SvgFacebook;